export default __webpack_public_path__ + "static/media/2.284daff7.png";